import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/States";
import AdminOverview from "@/components/admin/AdminOverview";
import AdminUsers from "@/components/admin/AdminUsers";
import AdminSubjects from "@/components/admin/AdminSubjects";
import AdminQuestions from "@/components/admin/AdminQuestions";
import AdminContent from "@/components/admin/AdminContent";
import AdminCourses from "@/components/admin/AdminCourses";
import AdminSettings from "@/components/admin/AdminSettings";
import AdminEnquiries from "@/components/admin/AdminEnquiries";
import AdminInterviews from "@/components/admin/AdminInterviews";
import AdminCertificates from "@/components/admin/AdminCertificates";
import AdminContacts from "@/components/admin/AdminContacts";
import AdminJobs from "@/components/admin/AdminJobs";
import AdminEmployers from "@/components/admin/AdminEmployers";
import AdminPlans from "@/components/admin/AdminPlans";

const TABS = [
  ["overview", "Overview", AdminOverview], ["questions", "Question bank", AdminQuestions], ["content", "AI content review", AdminContent],
  ["interviews", "Interview review", AdminInterviews],
  ["enquiries", "Enquiries", AdminEnquiries], ["certificates", "Certificates", AdminCertificates], ["contacts", "Employer contacts", AdminContacts], ["jobs", "Jobs", AdminJobs], ["employers", "Employers", AdminEmployers],
  ["subjects", "Subjects & topics", AdminSubjects], ["users", "Users", AdminUsers], ["plans", "Plans & pricing", AdminPlans], ["courses", "Courses", AdminCourses], ["settings", "AI settings", AdminSettings],
];

export default function Admin() {
  return (
    <div data-testid="admin-dashboard">
      <PageHeader eyebrow="Administration" title="Admin dashboard" text="Manage content quality, learners, courses and AI usage." />
      <Tabs defaultValue="overview">
        <TabsList className="mb-6 h-auto flex-wrap justify-start gap-1 bg-elevated p-1">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([v, , C]) => <TabsContent key={v} value={v}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
